import React, { useCallback } from "react";

import PropTypes from "prop-types";

import ButtonTertiary from "~components/molecules/button/button_tertiary/button_tertiary";

import { LINK } from "../../../../../prop_types";

function RscHbNavLink({
  title,
  link,
  isActive,
  index,
  onClick,
  isFontRegular,
}) {
  const handleButtonClick = useCallback(() => {
    onClick(index);
  }, [index, onClick]);

  return (
    <ButtonTertiary
      isFontRegular={isFontRegular}
      title={title}
      link={link}
      isActive={isActive}
      onClick={handleButtonClick}
    />
  );
}

RscHbNavLink.propTypes = {
  isFontRegular: PropTypes.bool,
  title: PropTypes.string,
  link: LINK,
  isActive: PropTypes.bool,
  index: PropTypes.number,
  onClick: PropTypes.func,
};

RscHbNavLink.defaultProps = {
  title: "",
  isFontRegular: false,
  link: null,
  isActive: false,
  index: null,
  onClick: () => {
    return null;
  },
};

export default RscHbNavLink;
